<template>
  <div>
    <div class="nav">
      <ul class="tabs-wrap">
        <li class="tab-item" :class="{ cu: navItem === 'report' }" @click="goPath('report')">
          主旨报告
        </li>
        <li class="tab-item" :class="{ cu: navItem === 'cooperation' }" @click="goPath('cooperation','inter')">
          海外合作
        </li>
        <li class="tab-item" :class="{ cu: navItem === 'learning' }" @click="goPath('learning')">
          学术发展
        </li>
        <li class="tab-item" :class="{ cu: navItem === 'digitization' }" @click="goPath('digitization')">
          数字化历程
        </li>
        <li class="tab-item" :class="{ cu: navItem === 'lookBack' }" @click="goPath('lookBack')">
          再回首
        </li>
      </ul>
    </div>
    <!-- 版心 -->
    <div class="detail-content" v-if="['report','learning','digitization'].includes(navItem)">
      <report v-if="navItem === 'report'" />
      <learning v-if="navItem === 'learning'" />
      <digitization v-if="navItem === 'digitization'"/>
    </div>
    <div v-else>
        <cooperation v-if="navItem === 'cooperation'"/>
        <lookback v-if="navItem === 'lookBack'" class="iframe-wrap animate__animated animate__zoomIn"/>
    </div>
    <div class="footer">CADAL项目管理中心</div>
  </div>
</template>

<script>
  import report from "./components/report.vue";
  import learning from "./components/learning.vue";
  import lookback from "./components/lookback.vue";
  import digitization from "./components/digitization.vue";
  import cooperation from "./components/cooperation.vue";

  export default {
    data() {
      return {
        navItem: "report"
      };
    },
    components: {
      report,
      learning,
      lookback,
      digitization,
      cooperation
    },
    created() {
      this.navItem = this.$route.query.type || "report";
    },
    mounted(){
      if(this.navItem === 'digitization'){
        // const elem =  document.getElementById('strip')
        // elem.scrollIntoView();
        this.$nextTick(_=>{
          document.body.scrollTop = 360
          document.documentElement.scrollTop = 360;
        })
      }
    },
    methods: {
      goPath(type,subType) {
        this.$router.push({
          path: '/detail',
          query:{
            type: type,
            subType:subType
          }
        })
      }
    }
  };

</script>

<style scoped lang="scss">
  .nav {
    height: 295px;
    width: 100%;
    background: url("../assets/image/detail_banner.png") center no-repeat;
    position: relative;

    .tabs-wrap {
      height: 40px;
      width: 1200px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      flex-wrap: nowrap;

      .tab-item {
        list-style: none;
        width: 150px;
        text-align: center;
        line-height: 40px;
        background: #ccc;
        margin-right: 20px;
        cursor: pointer;

        &.cu {
          background: #000;
          color: #fff;
        }

        &:not(.cu):hover {
          background: #000;
          color: #fff;
        }
      }
    }
  }

  .detail-content {
    width: 1200px;
    min-height: calc(100vh - 450px);
    margin: 20px auto;

    .iframe-wrap {
      width: 100%;
      overflow-x: hidden;
    }

    .look-iframe {
      width: calc(100% + 20px);
      height: calc(100vh - 380px);
      scrollbar-width: none;
      -ms-overflow-style: none;

      &::-webkit-scrollbar {
        display: none;
        /* Chrome Safari */
      }
    }
  }

  .footer {
    text-align: center;
    color: #999;
    line-height: 48px;
  }

</style>



// WEBPACK FOOTER //
// src/views/detail.vue